import axios from "../../config/axiosConfig";
import { CREATE_TDS_SECTION, GET_TDS_SECTION, TDS_SECTION_REQUEST, DELETE_TDS_SECTION, UPDATE_TDS_SECTION, TDS_SECTION_REQUEST_FAILURE } from "../types";
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getTdsSections = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: TDS_SECTION_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/tds-section/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_TDS_SECTION, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: TDS_SECTION_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: TDS_SECTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createTdsSection = (tdsSection) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: TDS_SECTION_REQUEST });
      return axios.post("/tds-section/add", tdsSection,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }
      }).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_TDS_SECTION, payload: response.data });
          dispatch(addMasterInOption('tdsSections', response.data));
        } else {
          dispatch({
            type: TDS_SECTION_REQUEST_FAILURE,
            error: "TDS Section create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: TDS_SECTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: TDS_SECTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateTdsSection = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: TDS_SECTION_REQUEST });
      const { auth } = getState();
      return axios.put("/tds-section/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_TDS_SECTION,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('tdsSections', id, response.data));
        } else {
          dispatch({
            type: TDS_SECTION_REQUEST_FAILURE,
            error: "TDS Section update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: TDS_SECTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: TDS_SECTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteTdsSection = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: TDS_SECTION_REQUEST });
      return axios.delete(`/tds-section/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_TDS_SECTION, id: id });
          dispatch(updateMasterInOption('tdsSections', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: TDS_SECTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: TDS_SECTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
